export default __webpack_public_path__ + "static/media/textAlign.5bd9ab79.png";